const advisorIdFromURL = location.hostname.split('.')[0];

export default advisorIdFromURL;
